import React, { useEffect, useState } from 'react';
import './BuyerProfile.scss';
import { PublicProfile } from './PublicProfile/PublicProfile';
import { useStateSelector } from '../../../../store/selectors';
import { useDispatch } from 'react-redux';
import { GetBuyer } from '../../../../slices/marketplace/buyer/thunks/get-buyer.thunk';
import { PrivateProfile } from './PrivateProfile/PrivateProfile';
import { LegalDocumentInputs } from './LegalDocumentInputs/LegalDocumentInputs';
import { ProfilePreview } from './ProfilePreview/ProfilePreview';

const BuyerProfile = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [isEditMode, setIsEditMode] = useState(false);
    const [tabData] = useState([
        'Public Profile',
        'Private Documents',
        'Legal Documents Inputs',
    ]);
    function renderTabContent() {
        const activeTabData = tabComponents.find((tab) => tab.id === activeTab);
        return (
            activeTabData?.content || (
                <div className="d-flex align-items-center justify-content-center mt-4">
                    <h1>Empty Tab</h1>
                </div>
            )
        );
    }
    useEffect(() => {
        fetchBuyerProfile();
    }, []);

    const dispatch = useDispatch() as any;
    const buyerProfile = useStateSelector((state) => state.buyersState.targetBuyer);

    const tabComponents = [
        {
            id: 0,
            content: (
                <PublicProfile setIsEditMode={setIsEditMode}></PublicProfile>
            ),
        },
        {
            id: 1,
            content: (
                <PrivateProfile setIsEditMode={setIsEditMode}></PrivateProfile>
            ),
        },
        {
            id: 2,
            content: (
                <LegalDocumentInputs
                    setIsEditMode={setIsEditMode}></LegalDocumentInputs>
            ),
        },
    ];

    const fetchBuyerProfile = async () => {
        await dispatch(GetBuyer(null));
    };

    const renderTabs = () => {
        return (
            <div className="buyer-profile practice-page-tabs m-0">
                <div className="RRT__container">
                    <div className="RRT__tabs body-tabs">
                        {tabData?.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    className={
                                        activeTab === index
                                            ? 'RRT__tab RRT__tab--first RRT__tab--selected'
                                            : 'RRT__tab'
                                    }
                                    onClick={() => {
                                        setActiveTab(index);
                                    }}>
                                    {item}
                                </div>
                            );
                        })}
                    </div>
                </div>
                {renderTabContent()}
            </div>
        );
    };

    const renderPreview = () => {
        return (
            <ProfilePreview
                isReadonly={false}
                setIsEditMode={setIsEditMode}></ProfilePreview>
        );
    };

    return buyerProfile && (isEditMode ? renderTabs() : renderPreview());
};

export default BuyerProfile;
